export default "__VITE_ASSET__DwCX6ycu__"